import * as React from "react";
import {useForm} from "react-hook-form";
import {useEffect} from "react";
import {JobPlan, JobPlanDescriptionForm, JobPlanForm} from "../../../../../../store/data/entities/job-plan";
import CoreForm from "../../../../../web-v2/components/CoreForm";
import {TextFieldController} from "../../../../../web-v2/components/forms/TextFieldController";
import {
  useGetAllAssetTypesQuery,
  useGetAllSubAssetTypesQuery
} from "../../../../../../store/services/api/asset-type-api";
import {PickerFieldController} from "../../../../../web-v2/components/PickerFieldController";
import {ScrollView, StyleSheet, Text, View} from "react-native";
import JobPlanItemDescriptionsForm from "./JobPlanItemDescriptionsForm";
import {FormButton} from "../../../../../web-v2/components/forms/FormButton";
import {useSetLoading} from "../../../../../../hooks/useSetLoading";
import AssetTypeSubAssetTypeCascader from "../../../../../../components/form-controls/AssetTypeSubAssetTypeCascader";
import GlobalStyle from "../../../../../../constants/GlobalStyle";

interface JobPlanManageFormProps {
  jobPlan?: JobPlan | undefined;
  onSubmit: (data: any) => void;
  onApproval: (isApproved?: boolean) => void;
  isApproval: boolean;
  readOnly: boolean;
}

export default function JobPlanManageForm({jobPlan, onSubmit, onApproval, isApproval, readOnly}: JobPlanManageFormProps) {

  const form = useForm<JobPlanForm>({
  defaultValues: {
    id: null,
    title: "",
    description: "",
    assetTypeSubAssetTypes: [],
    descriptions: []
  }
});


  const assetTypeSubAssetTypes = form.watch("assetTypeSubAssetTypes");

  const cascaderValue =
    assetTypeSubAssetTypes?.map(x => [
      x.assetTypeId,
      x.subAssetTypeId
    ]) ?? [];

  useEffect(() => {
  if (jobPlan) {
    form.setValue("id", jobPlan.id);
    form.setValue("title", jobPlan.title);
    form.setValue("description", jobPlan.description);

    form.setValue(
      "assetTypeSubAssetTypes",
      jobPlan.assetTypeSubAssetTypes ?? []
    );

    const descriptions: JobPlanDescriptionForm[] = jobPlan.descriptions?.map(item => ({
      id: item.id,
      description: item.description,
      imagesBase64: [],
      images: item.imageURIs?.map((image) => ({
        uri: image
      }))
    }));

      form.setValue("descriptions", descriptions);
    }
  }, [jobPlan]);


  const handleOnSubmit = () => {
  form.handleSubmit((data) => {

    const descriptions = data.descriptions.map((item) => ({
      ...item,
      imagesBase64: item.images.map((image) => image.uri)
    }));

    onSubmit({
      ...data,
      descriptions
    });

    })();
  };

  return (
    <>
      <View style={styles.formContainer}>
        <CoreForm
          style={styles.container}
          form={form}
          footer={null}
        >
          <TextFieldController
            disabled={isApproval || readOnly}
            controlName='title'
            title='Description'
            required
          />
          <Text style={GlobalStyle.form__column__text} >{'Asset Types / Sub Asset Types *'} </Text>
          <AssetTypeSubAssetTypeCascader
            disabled={isApproval || readOnly}
            value={cascaderValue}
            onChange={(value, pairs) => {
              form.setValue("assetTypeSubAssetTypes", pairs);
            }}
          />
        </CoreForm>

        <CoreForm
          style={styles.container}
          footer={null}
          form={form}
        >
          <ScrollView>
            <JobPlanItemDescriptionsForm
              isApproval={isApproval}
              readOnly={readOnly}
              control={form.control}
            />
          </ScrollView>
        </CoreForm>
      </View>
      {!readOnly &&
      <View style={styles.buttonContainer}>
        {isApproval ? (
          <>
            <FormButton title='APPROVE' onPress={() => onApproval(true)}/>
            <FormButton title='REJECT' type='danger' onPress={() => onApproval(false)}/>
          </>
        ) : (
          <FormButton title='SUBMIT' onPress={handleOnSubmit}/>
        )}
      </View>
      }
      
    </>
  )
}

const styles = StyleSheet.create({
  formContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    flex: 1,
    maxHeight: 600
  },
  container: {
    gap: 4,
    borderWidth: 1,
    borderColor: "#d9d9d9",
    borderRadius: 6,
    backgroundColor: "#fff",
    overflow: "hidden",
    flex: 1,
  },
  buttonContainer: {
    marginTop: 12,
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
    justifyContent: 'flex-start',
    maxWidth: 300,
  }
})
